import * as web3 from '@solana/web3.js';

export const FIRST_CREATOR_IS_LAST_INDEX = false ;//false; // change to false for mainnet as it's the first index 
                                                // instead of last


export const NETWORK = "mainnet-beta";

export const programId : web3.PublicKey = 

new web3.PublicKey("54hDEjFxUQY7eoCv9TPUhmbm2TxhffvNR1tm4eUJTbk8");

// for $DAWG token 
export const DC_TOKEN_DECIMAL = 9; 

export const DC_TOKEN_MINT = "9XczSh86n8XKkDuL4yK93afRHgSifui9j9sFPHQLfFUT";

//"9QKHcZihXMdBgYdrWgqXCP6o6GWWb9ttsqS7WXSVuJZ8";

// This is the wallet address that created the $DAWG token vault
export const DC_TOKEN_VAULT_OWNER = "48Dz31abNPM7NqHsA7StTu1WvAPfcE9z8Xnu15NnND1n";


// NFT token vault API URI
export const NFT_TOKEN_VAULT_API = "https://dd-staking-ui.vercel.app/api/tokenvault?mint=";

export const NFT_TOKEN_VAULT_FILE_WALLET = "91EjVBFAptp8g1f1QXykzHtF3r2o1aPzmfUiTJFMtmC4";

export const STAKE_DATA_API = "https://dd-staking-ui.vercel.app/api/stakeData";


export const SIGN_IN_API = "https://dd-staking-ui.vercel.app/api/signin";


export const SIGN_OUT_API = "https://dd-staking-ui.vercel.app/api/signout";

// for DC NFT 
export const DC_UPDATE_AUTHORITY = "Dcdhd8Cv2TJueYGPCii2cFePEi2AhJonjPr4kbNHmHEM";

export const DC_VALID_FIRST_CREATOR = "";
